import { AxiosResponse } from 'axios';
import $http from 'services/http.service';
import i18n from 'services/i18n.service';
import { clientId, env, isApp, passwordResetToken, redirectUri, responseType } from 'utils/helper.utils';

type ResetPasswordParams = { email: string; register: boolean };
type ResetPasswordResponse = { message: string };

// sends out password reset email on success
export async function resetPassword(params: ResetPasswordParams): Promise<AxiosResponse<ResetPasswordResponse>> {
  const data = { ...params, locale: i18n.language, app: isApp };
  const response = await $http.post<ResetPasswordResponse>('/reset-password', data, {
    headers: {
      'client-id': isApp ? (env.REACT_APP_DEFAULT_CLIENT_ID as string) : clientId,
      'redirect-uri': isApp ? (env.REACT_APP_DEFAULT_REDIRECT_URL as string) : redirectUri,
      'response-type': isApp ? 'code' : responseType
    }
  });
  return response;
}

type SetPasswordResponse = { message: string };

export async function changePassword(password: string, passwordConfirm: string): Promise<AxiosResponse<SetPasswordResponse>> {
  const data = { password, passwordConfirm };
  const response = await $http.post<SetPasswordResponse>('/set-password', data, {
    headers: {
      'client-id': clientId,
      'redirect-uri': redirectUri,
      'reset-token': passwordResetToken
    }
  });
  return response;
}

/**
 * Validate password according to the following requirements:
 * - At least 10 characters long
 * - At least one lowercase letter
 * - At least one uppercase letter
 * @param {string} value - The password to validate
 * @returns {string | true} - Returns true if valid, otherwise return the translation key of the error message
 */
export function validatePassword(value: string): string | true {
  if (value.length < 10) return 'passwordTooShort';
  if (/[a-z]/.test(value) === false) return 'passwordMustContainLowercase';
  if (/[A-Z]/.test(value) === false) return 'passwordMustContainUppercase';
  return true;
}
